(() => {
  const source = document.currentScript;
  if (!source || !document.body) return;

  const labels = new Map([
    ['ge-personalize', source.dataset.personalize],
    ['ge-close', source.dataset.backToShop],
    ['ge-add-to-cart', source.dataset.addToCart],
  ]);
  const selector = 'button#ge-personalize, button#ge-close, button#ge-add-to-cart';

  const translate = (button) => {
    const label = labels.get(button.id);
    if (label && button.childElementCount === 0 && button.textContent !== label) {
      button.textContent = label;
    }
  };

  document.querySelectorAll(selector).forEach(translate);

  const observer = new MutationObserver((records) => {
    const buttons = new Set();
    for (const record of records) {
      const target = record.target.nodeType === Node.ELEMENT_NODE
        ? record.target
        : record.target.parentElement;
      const button = target?.closest(selector);
      if (button) buttons.add(button);

      for (const node of record.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        if (node.matches(selector)) buttons.add(node);
        node.querySelectorAll(selector).forEach((added) => buttons.add(added));
      }
    }
    buttons.forEach(translate);
  });

  observer.observe(document.body, {
    childList: true,
    characterData: true,
    subtree: true,
  });
})();
